import Vue from 'vue'
import Vuex from 'vuex'
import uistate from './uistate'
import conversation from './conversation'
import nudging from './nudging'
// import createLogger from 'vuex/dist/logger'
import ChatSession from '../helpers/chatsession'

import survey from 'sanitas-survey-vue2/src/store/survey'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    uistate,
    conversation,
    nudging,
    survey
  },
  actions: {
    restoreSession: (context) => {
      let session, chatApi
      session = Vue.prototype.$session
      chatApi = Vue.prototype.$chatApi

      const chatUrlTrigger = 'sanitas-chat-action=open' // TODO: move to consts
      const { channel } = window._sanChatConfig
      if ((window.location.hash + window.location.search).indexOf(chatUrlTrigger) !== -1) {
        session.set(channel + 'chatOpen', true)
      }
      return ChatSession.restoreSession(session, chatApi, context, channel)
    }
  },
  strict: debug,
  plugins: [ ChatSession.vuexPlugin ] /* ,
  plugins: debug ? [createLogger()] : [] */
})
